var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"party",class:{'transparent-background': _vm.transparentBackground}},[_c('div',{staticClass:"absolute-wrap"},[_c('canvas',{ref:"partyCanvas"})]),_c('div',{staticClass:"absolute-wrap"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }